export default "__VITE_ASSET__DYNFchqt__"